import { cmsLevelColor } from '../constants/CMSEventConstants'

const getCmsLevelColor = lvl => cmsLevelColor[lvl]

export { getCmsLevelColor }
